import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Button } from '@/design-system/components/Button';
import { useI18n } from '@/i18n/context';
import styles from './RouteErrorPage.module.css';

/**
 * Router error boundary (render errors, failed lazy-chunk loads after a deploy).
 * Never shows raw error details to users; they are logged for developers.
 */
export function RouteErrorPage() {
  const { t } = useI18n();
  const error = useRouteError();
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>{t.errors.routeErrorTitle}</h1>
        <p className={styles.body}>{t.errors.routeErrorBody}</p>
        <div className={styles.actions}>
          <Button onClick={() => window.location.reload()}>{t.errors.reload}</Button>
          <a href="/" className={styles.link}>
            {t.errors.goHome}
          </a>
        </div>
      </div>
    </main>
  );
}
